import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { ModalController } from '@ionic/angular';
import { AssetService } from 'src/app/services/asset/asset.service';
import { ClientService } from 'src/app/services/client/client.service';
import { UserModel } from 'src/app/models/user.model';
import { Constants } from 'src/app/constants/constants';


@Component({
  selector: 'modal-user',
  templateUrl: './modal-new-user.component.html',
  styleUrls: ['./modal-new-user.component.scss'],
})
export class ModalNewUserComponent implements OnInit {

  newUser: UserModel;

  emailError: boolean = false;
  passwordError: string = null;
  userRoleError: boolean = false;
  firstNameError: boolean = false;
  lastNameError: boolean = false;
  addressOneError: boolean = false;
  addressTwoError: boolean = false;
  addressCityError: boolean = false;
  postCodeError: boolean = false;


  constructor(public appearanceService: AppearanceService,
   public userService: UserService, public modalController: ModalController,
   public assetService: AssetService, public clientService: ClientService) {

  }


  ngOnInit() 
  {
    this.newUser = new UserModel();
    this.newUser.email = "";
    this.newUser.password = "";
    this.newUser.confirmPassword = "";
    this.newUser.addressOne = "";
    this.newUser.addressTwo = "";
    this.newUser.city = "";
    this.newUser.postCode = "";
    this.newUser.firstName = "";
    this.newUser.lastName = "";
    this.newUser.clientUid = this.clientService.getClientUid();
    this.newUser.userRoleUid = null;
  }


  ionViewWillEnter()
  {
    this.newUser = new UserModel();
    this.newUser.email = "";
    this.newUser.password = "";
    this.newUser.confirmPassword = "";
    this.newUser.addressOne = "";
    this.newUser.addressTwo = "";
    this.newUser.city = "";
    this.newUser.postCode = "";
    this.newUser.firstName = "";
    this.newUser.lastName = "";
    this.newUser.clientUid = this.clientService.getClientUid();
    this.newUser.userRoleUid = null;
  }


  ionViewWillLeave()
  {

  }


  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'NewUserModal');
  }


  userRoleSelected()
  {

  }


  createNewUser()
  {
    var errorFound = false;

    this.emailError = this.userRoleError = this.firstNameError = 
    this.lastNameError = this.addressOneError = this.addressTwoError = this.addressCityError =
    this.postCodeError = false;

    this.passwordError = null;


    if (this.newUser.email == "")
    {
      this.emailError = true;
      errorFound = true;
    }

    if (this.newUser.firstName == "")
    {
      this.firstNameError = true;
      errorFound = true;
    }

    if (this.newUser.lastName == "")
    {
      this.lastNameError = true;
      errorFound = true;
    }

    if (this.newUser.addressOne == "")
    {
      this.addressOneError = true;
      errorFound = true;
    }

    if (this.newUser.addressTwo == "")
    {
      this.addressTwoError = true;
      errorFound = true;
    }

    if (this.newUser.city == "")
    {
      this.addressCityError = true;
      errorFound = true;
    }

    if (this.newUser.postCode == "")
    {
      this.postCodeError = true;
      errorFound = true;
    }

    if (this.newUser.password == "")
    {
      this.passwordError = "Please enter a password";
      errorFound = true;
    }
    else
    {
      if (this.newUser.password != this.newUser.confirmPassword)
      {
        this.passwordError = "Passwords dont match";
        errorFound = true;
      }
    }

    if (!this.newUser.userRoleUid)
    {
      this.userRoleError = true;
      errorFound = true;
    }

    if (errorFound)
    {
      return;
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.clientService.createNewUser(this.newUser).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          var returnData = { userAdded: true };
          this.closeModal(returnData);
          this.appearanceService.presentToast("User added.", Constants.TOAST_SUCCESS);
        }
        else
        {
            this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }
}
